<template>
  <div>
    <iframe
      v-if="str.length"
      class="iframe"
      :src="str"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  data() {
    return {
      str: "",
    };
  },
  created() {
    // 获取小程序传递过来的参数
    this.str = decodeURIComponent(JSON.stringify(window.location.search.substr(5))).split("\"")[1];
    document.title = "远程诊疗中心";
    let that = this;
    // 监听返回
    this.pushHistory();
    window.addEventListener(
      "popstate",
      function() {
        //为了避免只调用一次
        that.pushHistory("title1");
        // 自定义方法, 直接关闭网页或返回小程序上一页
        that.goBack();
      },
      false
    );
  },
  mounted() {
  },
  methods: {
    // 插入浏览器历史
    pushHistory(str = "title", url = "") {
      let state = {
        title: str,
        url
      };

      window.history.pushState(state, state.title, state.url);
    },
    goBack() {
      /* eslint-disable */
      wx.miniProgram.navigateBack();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iframe {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  z-index: 9999;
}
</style>
